import React, { FunctionComponent, useEffect, useCallback } from 'react';
import { TSectionsKeys } from '../../../customise/model/IStoreTypes';
import { customiseActions } from '../../../customise/store/reducers/customiseReducer';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomiseSelectedSection } from '../../../customise/store/selectors/customiseSelectors';
import useNavigationBarItems from '../../../customise/react/navigation/useNavigationBarItems';
import useScrollToSection from '../../../customise/react/navigation/useScrollToSection';
import initialState from '../../../customise/store/initialState';
import useUpdateNavBarOnScroll from '../../hooks/navigation/useUpdateNavBarOnScroll';
import customise from '../../../customise/constants/customise';
import NavigationBar from '../../../gqlCommon/components/navigation/navigationBar/NavigationBar';
import { ScrollInViewBehaviourType } from '../../service/scrollInView';

interface INavigationBarContainerProps {
  isStockDetail?: boolean;
}

const NavigationBarContainer: FunctionComponent<INavigationBarContainerProps> = ({ isStockDetail }) => {
  const dispatch = useDispatch();
  const selectedSection = useSelector(getCustomiseSelectedSection);
  const { navigationItems } = useNavigationBarItems(isStockDetail);
  const sections: string[] = Object.keys(initialState.customiseInitialState.sections);
  const { currentElement } = useUpdateNavBarOnScroll(sections, customise.DOM_ID_PREFIX);
  const { scrollToSection } = useScrollToSection();

  useEffect(() => {
    if (currentElement) {
      const currentElementSelected = currentElement as unknown as TSectionsKeys;
      dispatch(customiseActions.setSelectedSection(currentElementSelected));
    }
  }, [currentElement]);

  const handleScroll = useCallback(
    (name: string) => {
      scrollToSection(name, ScrollInViewBehaviourType.SMOOTH);
    },
    [scrollToSection],
  );

  return <NavigationBar items={navigationItems} onClick={handleScroll} activeItem={selectedSection} />;
};

export default NavigationBarContainer;
